import { useEffect } from "react";

import { useFetchProductTypesQuery } from "@src/generated";

export function useProductTypes(options?: { skip?: boolean }) {
  const { data, loading, fetchMore } = useFetchProductTypesQuery({
    variables: { cursor: null },
    skip: options?.skip,
  });
  const hasNextPage = data?.productTypes?.pageInfo.hasNextPage;
  const cursor = data?.productTypes?.pageInfo.endCursor;
  useEffect(() => {
    if (!loading && hasNextPage && cursor) {
      void fetchMore({
        variables: { cursor },
      });
    }
  }, [loading, hasNextPage, cursor]);
  return data;
}
